import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterUsersExtendedValue,
  UniversalFilterUsersExtendedModes,
  UniversalFilterUsersExtendedFilterOptions,
  UniversalFilterUsersExtendedOnChange
} from './UniversalFilterUsersExtended.types';

import { useUniversalFilterUsersExtended } from './hooks/useUniversalFilterUsersExtended';

import { UsersMultiSelect } from '../../../../../main/users/helpers/UsersMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterUsersExtendedProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterUsersExtendedValue;
  i18nName: I18nText;
  options?: UniversalFilterUsersExtendedFilterOptions;
  autoFocus?: boolean;
  onChange: UniversalFilterUsersExtendedOnChange;
}

function UniversalFilterUsersExtended({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  options,
  autoFocus,
  onChange
}: UniversalFilterUsersExtendedProps) {
  const { modeOptions, filterState, handleModeChange, handleUserIdsChange } =
    useUniversalFilterUsersExtended({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterUsersExtendedModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [
          UniversalFilterUsersExtendedModes.CONTAINS_ANY_OF,
          UniversalFilterUsersExtendedModes.DOES_NOT_CONTAIN_ANY_OF
        ],
        filterState.mode
      ) ? (
        <UsersMultiSelect
          value={filterState.userIds || []}
          initialFilters={options?.initialUsersFilters}
          withoutRecentUsers={options?.withoutRecentUsers}
          autoFocus={autoFocus}
          inputWrapperClassName="block"
          onChange={handleUserIdsChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterUsersExtended;
